@if (shouldShowCurrentContractComponent()) {
  <wl-commodity-offer-header
    class="d-block my-2"
    [alignment]="'horizontal'"
    [headerTitle]="content()?.currentContractTitle"
  ></wl-commodity-offer-header>
  @switch (envConfig.brand) {
    @case ('essent') {
      <wl-essent-current-contract-card
        class="mb-3"
        [currentContract]="currentContract()"
        [content]="content()"
        (viewTariffs)="viewTariffs.emit($event)"
        [showLoadingState]="currentContractLoading()"
        [openCard]="!collapseEssentCurrentOfferCard()"
      >
      </wl-essent-current-contract-card>
    }
    @case ('ed') {
      <!-- ED not supported yet -->
    }
  }

  <hr class="mb-0" />
  <wl-commodity-offer-calculation-based-on
    class="d-block my-2"
    [variant]="'wide'"
    [label]="content()?.calculationBasedOnLabel"
    [address]="supplyAddress()"
    [consumptions]="consumptionValues()"
    [electricityLabel]="'ElectricityUsageUnit' | translate"
    [gasLabel]="'GasUsageUnit' | translate"
    [adjustCalculationLabel]="content()?.adjustCalculationLabel"
    (adjustCalculation)="adjustCalculation.emit()"
  ></wl-commodity-offer-calculation-based-on>
  <wl-commodity-offer-header
    [id]="commodityOfferHeaderId"
    class="d-block my-2"
    [alignment]="'horizontal'"
    [headerTitle]="content()?.componentTitle"
  ></wl-commodity-offer-header>
  @if (questionnaireResults()) {
    <wl-commodity-best-offer-list
      [offers]="offers()"
      [alignment]="'horizontal'"
      [content]="content()"
      [showMemberGetMember]="showMemberGetMember()"
      (selectOffer)="selectOffer.emit($event)"
      (openMoreInfo)="openMoreInfo.emit($event)"
      (viewTariffs)="viewTariffs.emit($event)"
      [questionnaireResults]="questionnaireResults()"
      wlAutomationId="horizontal-commodity-offer-list"
      (showExplanation)="showQuestionnaireExplanation.emit($event)"
      (selectVariableOffer)="selectVariableOffer.emit()"
    ></wl-commodity-best-offer-list>
  } @else {
    <wl-commodity-offer-list
      [offers]="offers()"
      [alignment]="'horizontal'"
      [content]="content()"
      [showMemberGetMember]="showMemberGetMember()"
      (selectOffer)="selectOffer.emit($event)"
      (openMoreInfo)="openMoreInfo.emit($event)"
      (viewTariffs)="viewTariffs.emit($event)"
      wlAutomationId="horizontal-commodity-offer-list"
    ></wl-commodity-offer-list>
  }

  <wl-horizontal-commodity-offer-footer
    [productBenefits]="content()?.offerFootNote"
    [contactInformation]="content()?.componentFootNote"
  ></wl-horizontal-commodity-offer-footer>
} @else {
  <wl-commodity-offer-header
    [id]="commodityOfferHeaderId"
    [alignment]="'horizontal'"
    [headerTitle]="content()?.componentTitle"
  ></wl-commodity-offer-header>
  <wl-commodity-offer-calculation-based-on
    [variant]="'wide'"
    [label]="content()?.calculationBasedOnLabel"
    [address]="supplyAddress()"
    [consumptions]="consumptionValues()"
    [electricityLabel]="'ElectricityUsageUnit' | translate"
    [gasLabel]="'GasUsageUnit' | translate"
    [adjustCalculationLabel]="content()?.adjustCalculationLabel"
    (adjustCalculation)="adjustCalculation.emit()"
  ></wl-commodity-offer-calculation-based-on>
  <hr class="mb-3" />
  @if (questionnaireResults()) {
    <wl-commodity-best-offer-list
      [offers]="offers()"
      [alignment]="'horizontal'"
      [content]="content()"
      [showMemberGetMember]="showMemberGetMember()"
      (selectOffer)="selectOffer.emit($event)"
      (openMoreInfo)="openMoreInfo.emit($event)"
      (viewTariffs)="viewTariffs.emit($event)"
      [questionnaireResults]="questionnaireResults()"
      wlAutomationId="horizontal-commodity-offer-list"
      (showExplanation)="showQuestionnaireExplanation.emit($event)"
      (selectVariableOffer)="selectVariableOffer.emit()"
    ></wl-commodity-best-offer-list>
  } @else {
    <wl-commodity-offer-list
      [offers]="offers()"
      [alignment]="'horizontal'"
      [content]="content()"
      [showMemberGetMember]="showMemberGetMember()"
      (selectOffer)="selectOffer.emit($event)"
      (openMoreInfo)="openMoreInfo.emit($event)"
      (viewTariffs)="viewTariffs.emit($event)"
      wlAutomationId="horizontal-commodity-offer-list"
    ></wl-commodity-offer-list>
  }
  <wl-horizontal-commodity-offer-footer
    [productBenefits]="content()?.offerFootNote"
    [contactInformation]="content()?.componentFootNote"
  ></wl-horizontal-commodity-offer-footer>
}
